// extracted by mini-css-extract-plugin
export default {"userNav":"user_nav_userNav__x8sPH","groupIconContainer":"user_nav_groupIconContainer__TuT9d","leftSide":"user_nav_leftSide__b04WZ","logoutBtn":"user_nav_logoutBtn__UcdKs"};